import { ref, computed } from 'vue'
import { defineStore, storeToRefs } from 'pinia'
import { v4 as uuidv4 } from 'uuid';
import * as Sentry from '@sentry/vue'


export interface Toast {
    id: string,
    variant: string,
    message: string,
    error_id?: string
}
export const useToastsStore = defineStore('toasts', () => {
    const toasts = ref<Toast[]>([])
    const warning = (message: string) => {
        queue("warning", message)
    }
    const error = (message: string) => {
        queue("error", message, get_current_error_id.value)
    }
    const success = (message: string) => {
        queue("success", message)
    }

    const queue = (variant: string, message: string, error_id?: string) => {
        const id = uuidv4();
        toasts.value.push({ id, variant, message, error_id })
        setTimeout(() => {
            remove(id)
        }, 4000)
    }

    const remove = (id: string) => {
        toasts.value = toasts.value.filter(toast => toast.id !== id)
    }

    const get_current_error_id = computed(() => {
        const scope = Sentry.getCurrentScope().lastEventId()
        return scope
    })

    return { toasts, warning, error, success }
})

